export default "__VITE_ASSET__CI6Nrq70__"